import { useEffect } from "react";
import ModalComponent from "../../../shared/components/Modals/ModalComponent";
import ModalBody from "../../../shared/components/Modals/ModalBody";
import EvaluationSections from "./evaluationQuestions";
import { selectAiEvaluationId, selectIsViewEvaluationModalOpen, setIsViewEvaluationModalOpen } from "../../interview/slice/interviewSlice";
import { useSelector, useDispatch } from "react-redux";
import { useGetEvaluationByIdQuery } from "../../interview/slice/interviewApiSlice";
import LazyLoader from "../../../shared/components/LazyLoader/load";
import { message } from "antd";
import { errorMessage } from "../../../shared/utils/constantData";
const ViewEvaluationModal = () => {
    const isOpen = useSelector(selectIsViewEvaluationModalOpen);
    const aiEvaluationId = useSelector(selectAiEvaluationId);
    const dispatch = useDispatch();
    const { isLoading, isError, error, data } = useGetEvaluationByIdQuery(aiEvaluationId ,{skip: !isOpen});

    useEffect(() => {
        if(isError) {
            message.error(errorMessage);
            dispatch(setIsViewEvaluationModalOpen(false));
        }
    }, [isError, error, dispatch])

    const handleCloseModal = () => {
        dispatch(setIsViewEvaluationModalOpen(false));
    }
    
    return (
        <ModalComponent
            visibleModal={isOpen}
            width={1010}
            handleCloseModal={handleCloseModal}
            content={
                <ModalBody
                    title={
                        <header className="flex items-center gap-2">
                            <h2 className="capitalize text-gray-600 text-xl font-medium mb-5">
                                {data?.data?.evaluation?.title}
                            </h2>
                        </header>
                    }
                >
                    {
                        isLoading ? 
                            <div className='w-full mb-auto'>
                                <LazyLoader />
                                <p className='mt-4 text-base font-normal text-indigo-600'>Retrieving Evaluation..</p>
                            </div>
                            : <main className="px-5 text-start">
                                <section>
                                    <h5
                                        id="summary-title"
                                        className="uppercase text-xs font-semibold mb-1"
                                    >
                                        {data?.data?.evaluation?.sections?.generalEvaluation?.title}
                                    </h5>
                                    <p className="font-light text-sm">
                                        {data?.data?.evaluation?.sections?.generalEvaluation?.summary}
                                    </p>
                                </section>

                                {data?.data?.evaluation?.sections?.evaluationMetrics?.map((section : any, index: number) => (
                                    <EvaluationSections key={section?.id} section={section} isLastSection={index === data?.data?.evaluation?.sections?.evaluationMetrics?.length - 1} />
                                ))}
                        </main>
                    }
                </ModalBody>
            }
        />
    );
};

export default ViewEvaluationModal;
